"use client"

import Script from "next/script"
import { extractProperty } from "utils"

type Props = {
  pageData: any
}

function ScriptInjection({ pageData }: Props) {
  const gtmId = extractProperty(pageData, "scriptGtmId") as string | undefined
  const gtmEnabled = extractProperty(pageData, "scriptGtmEnabled")
  const headScripts = extractProperty(pageData, "scriptHeadCustom") as string | undefined
  const bodyEndScripts = extractProperty(pageData, "scriptBodyEndCustom") as string | undefined

  const isGtmActive = gtmEnabled === true || gtmEnabled === "1" || gtmEnabled === "true"

  return (
    <>
      {/* GTM */}
      {isGtmActive && gtmId && (
        <>
          <Script
            id="mlp-gtm-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtmId}');
              `,
            }}
          />
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
            />
          </noscript>
        </>
      )}

      {/* Custom head scripts */}
      {headScripts && (
        <Script
          id="mlp-head-custom"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{ __html: headScripts }}
        />
      )}

      {/* Custom body-end scripts */}
      {bodyEndScripts && (
        <Script
          id="mlp-body-end-custom"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{ __html: bodyEndScripts }}
        />
      )}
    </>
  )
}

export default ScriptInjection
